// extracted by mini-css-extract-plugin
module.exports = {"card__title":"styles_card__title__bGuyy","card":"styles_card__3BB9u"};